import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { faceDetectedRecord } from "assets";
import Camera from "./Camera";
import { useNavigate } from "react-router-dom";
import RecordingIcon from "../../assets/images/fad_armrecording.svg";
import { faceDetected, livenessDetected } from "assets";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100%;
  background-color: #f8f8f8;
  position: absolute;
`;

const DetectionContainer = styled.div<{ height?: number }>`
  position: relative;
  gap: 12px;
  padding: 30px 24px;
  flex-direction: column;
  border-radius: 12px 12px 0px 0px;
  display: flex;
  background: rgb(255, 255, 255);
  box-shadow: rgba(47, 49, 59, 0.12) 0px -6px 4px 0px;

  height: ${(props) => props.height && props.height}px;
  max-height: ${(props) => props.height && props.height}px;
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: 15px;
`;

const Message = styled.p`
  color: #2f313b;

  /* Text-18px */
  font-family: sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
`;
const DetectionStatus = styled.div`
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  gap: 10px;
  position: absolute;
  top: 8px;
  left: 10px;
`;

const StatusIcon = styled.img`
  height: 10px;
  width: 10px;
  margin: 0 7px 0 0;
`;

const StatusBadge = styled.div<{ type?: string }>`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 11px;
  color: #fff;
  background-color: ${(props) =>
    props.type === "success" ? "#05A8AA" : "#FFC107"};
`;

const Message2 = styled.p`
  color: #2f313b;

  /* Text-18px */
  font-family: sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 10px;
`;

const StartButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px;
  font-size: 20px;
  background-color: ${(props) => (props.disabled ? `lightgray` : "#000")};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #555;
  }
`;
const StartButton2 = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px;
  font-size: 20px;
  border-radius: 6px;
  border: 1px solid rgba(47, 49, 59, 0.5);
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;
  &:hover {
    background-color: #555;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
`;
const CustomFont = styled.span`
  color: #2f313b; /* Text Color */
  font-family: "sans-serif", sans-serif; /* Font Family */
  font-size: 14px; /* Text Size */
  font-style: normal;
  font-weight: 600; /* Boldness */
  line-height: 18.2px; /* Line Height (130%) */
`;

const StopRecordButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 2px;
  display: flex;
  align-items: center; /* ✅ Ensures vertical alignment */
  justify-content: center;
  gap: 10px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #d80909;
  background: #fff;
  cursor: pointer;
  transition: background-color 0.3s;
  color: #d80909;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "sans-serif", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 30px;

  &:hover {
    background-color: #555;
  }
`;

const Icon2 = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  vertical-align: middle; /* ✅ Helps with text alignment */
  display: inline-block;
`;

const RecordProcess = styled.div<{ status?: string }>`
  font-weight: 400;
  font-size: 16px;

  color: ${(props) => {
    if (props.status === "recording") return "#DA3131";
    if (props.status === "uploading") return "#00FF00";
    return "transparent";
  }};
`;

interface FaceAndLivenessProps {
  isFaceDetected: boolean;
  isLivenessDetected: boolean;
  handleStartRecording?: () => void;
  handleFaceAndLiveliness?: () => void;
  recordingStatus: string;
  handleStopRecording: () => void;
  // videoBlob: Blob | null;
}

const FaceAndLiveness: React.FC<FaceAndLivenessProps> = ({
  isFaceDetected,
  isLivenessDetected,
  handleStartRecording,
  handleFaceAndLiveliness,
  recordingStatus,
  handleStopRecording,
  // videoBlob,
}) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [isRecordingStarted, setIsRecordingStarted] = useState(false);
  const [isRecordingStopped, setIsRecordingStopped] = useState(false);
  // const videoRef = useRef<HTMLVideoElement | null>(null);
  const navigate = useNavigate();

  const handleAcknowledge = () => {
    setIsAcknowledged(!isAcknowledged);
    handleFaceAndLiveliness();
  };

  const handleRecording = () => {
    setIsRecordingStarted(!isRecordingStarted);
    handleStartRecording();
  };

  const handleStopRecordingClick = () => {
    setIsRecordingStarted(false);
    setIsRecordingStopped(true); // Show re-record and upload options
    handleStopRecording();
  };
  const handleUpload = () => {
    setIsRecordingStopped(false);
    navigate("/addBmi"); // Navigate to AddBmi page
  };

  const handleReRecord = () => {
    setIsRecordingStopped(false);
    setIsRecordingStarted(true);
    handleStartRecording();
  };

  return (
    <Container>
      <Camera
        isFaceDetected={isAcknowledged ? isFaceDetected : false}
        isLivenessDetected={isAcknowledged ? isLivenessDetected : false}
        isAcknowledged={isAcknowledged}
      />

      {isRecordingStarted ? (
        <>
          <DetectionContainer height={250}>
            <Message2>Please read the below text aloud</Message2>
            <CustomFont>
              I am aware of the terms and conditions of the policy. This is a
              life insurance policy and not a health insurance, bank loan,
              credit card or FD. I have to pay minimum of{" "}
              <strong>Rs. 1,04,500</strong> for <strong>5 years</strong>.
            </CustomFont>

            <RecordProcess status={recordingStatus}>
              {recordingStatus === "recording" && "Recording..."}
            </RecordProcess>

            <ButtonContainer>
              <StopRecordButton onClick={handleStopRecordingClick}>
                <Icon2 src={RecordingIcon} alt="Recording Icon" />
                Stop Recording
              </StopRecordButton>
            </ButtonContainer>
          </DetectionContainer>
        </>
      ) : isRecordingStopped ? (
        <DetectionContainer height={250}>
          <Message2>Please read the below text aloud</Message2>
          <CustomFont>
            I am aware of the terms and conditions of the policy. This is a life
            insurance policy and not a health insurance, bank loan, credit card
            or FD. I have to pay minimum of <strong>Rs. 1,04,500</strong> for{" "}
            <strong>5 years</strong>.
          </CustomFont>
          <ButtonContainer>
            <StartButton2 onClick={handleReRecord}>Re-Record</StartButton2>
            <StartButton2 onClick={handleUpload}>Next</StartButton2>
          </ButtonContainer>
        </DetectionContainer>
      ) : isAcknowledged && isFaceDetected && isLivenessDetected ? (
        <DetectionContainer height={145}>
          <DetectionStatus>
            {isFaceDetected && (
              <StatusBadge type="success">
                <StatusIcon src={faceDetected} /> Face Detected
              </StatusBadge>
            )}
            {isLivenessDetected && (
              <StatusBadge type="success">
                <StatusIcon src={livenessDetected} /> Liveness Detected
              </StatusBadge>
            )}
          </DetectionStatus>
          <Message2>
            Please click Start Video Recording and read the text aloud which
            appears next.
          </Message2>
          <StartButton onClick={handleRecording}>
            Start Video Recording
          </StartButton>
        </DetectionContainer>
      ) : isAcknowledged ? (
        <DetectionContainer height={140}>
          <Icon
            src="/src/assets/images/lucide_scan-face.svg"
            alt="Liveness Check Icon"
          />
          <Message>Please position your face in front of the camera.</Message>
        </DetectionContainer>
      ) : (
        <DetectionContainer height={190}>
          <Icon
            src="/src/assets/images/lucide_scan-face.svg"
            alt="Liveness Check Icon"
          />
          <Message>Please position your face in front of the camera.</Message>
          <StartButton onClick={handleAcknowledge}>Proceed</StartButton>
        </DetectionContainer>
      )}
    </Container>
  );
};

export default FaceAndLiveness;
